module.exports = __webpack_public_path__ + "static/img/休眠.e346b78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/车辆/挖掘机/休眠.png
// module id = /WTG
// module chunks = 76